import { Row, Col } from 'react-bootstrap';
import CurrencyField from '../../fields/CurrencyField';
import PercentageField from '../../fields/PercentageField';
import AdditionalInformationField from '../../fields/AdditionalInformationField';
import SubmissionTypeField from '../../fields/SubmissionTypeField';
import IncomeMeasurementSelector from '../../common/IncomeMeasurementSelector';

const PpcSection = ({
  state,
  incomeMeasurementType,
  onIncomeMeasurementTypeChange,
  incomeMeasurementPercentage,
  onIncomeMeasurementPercentageChange,
  energyDiscount,
  arrearage,
  pledgeAmount,
  onPledgeAmountChange,
  submissionType,
  onSubmissionTypeChange,
  additionalInformation,
  onAdditionalInformationChange,
  isSubmitting,
}) => {
  return (
    <>
      <hr />

      {/* Income Measurement */}
      <IncomeMeasurementSelector
        state={state}
        incomeMeasurementType={incomeMeasurementType}
        onIncomeMeasurementTypeChange={onIncomeMeasurementTypeChange}
        incomeMeasurementPercentage={incomeMeasurementPercentage}
        onIncomeMeasurementPercentageChange={onIncomeMeasurementPercentageChange}
        isSubmitting={isSubmitting}
        required
      />

      {/* Calculated Results (placeholders for now) */}
          <hr />
                {/* Benefit Amount */}
      <Row>
        <Col><h4>Benefit Amounts</h4>
          <Row>
            <Col md={4}>
              <PercentageField
                value={energyDiscount}
                fieldName="Energy Discount"
                readonly
                disabled
              />
            </Col>
            <Col md={4}>
              <PercentageField
                value={arrearage}
                fieldName="Arrearage"
                readonly
                disabled
              />
            </Col>
            <Col md={4}>
            <CurrencyField
                value={pledgeAmount}
                fieldName="Pledge Amount"
                onChange={onPledgeAmountChange}
                isSubmitting={isSubmitting}
            />
            </Col>
        </Row>

        <hr/>

        {/* Submission Type */}
        <Row>
            <Col>
            <SubmissionTypeField
                value={submissionType}
                onChange={onSubmissionTypeChange}
                isSubmitting={isSubmitting}
            />
            </Col>
        </Row>

        <hr />

        {/* Additional Information */}
        <Row>
            <Col>
            <AdditionalInformationField
                value={additionalInformation}
                onChange={onAdditionalInformationChange}
                isSubmitting={isSubmitting}
            />
            </Col>
        </Row>
    </Col>
        </Row>
    </>
  );
};

export default PpcSection;